import { CategoryInterface } from "../interfaces/CategoryInterface";

export const findMatchingCategories = (
    categories: CategoryInterface[],
    productCategoryIds: number[],
): CategoryInterface[] => {
    const matchingCategories: CategoryInterface[] = [];

    const searchRecursively = (cats: CategoryInterface[]): void => {
        for (const cat of cats) {
            if (productCategoryIds.includes(cat.id)) {
                matchingCategories.push(cat);
            }

            if (cat.children && cat.children.length > 0) {
                searchRecursively(cat.children);
            }
        }
    };

    searchRecursively(categories);
    return matchingCategories;
};
